import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import Images from 'assets/images/imageData';

const ViewPocs = ({
  match,
  getPocListing = null,
  pocList = null,
  updatePocStatus = null,
  updateStatus = null,
}) => {
  const headers = [
    'POC Name',
    'POC Designation',
    'Mobile Number',
    'Email Address',
    'Active/Inactive',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [reqData, setReqData] = useState();
  const [leadId, setLeadId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/add-poc/${leadId}`}
          className="btn btn-primary d-md-inline-block"
        >
          Add POC
          <img src={Images?.ArrowRight} alt="Add POC" />
        </Link>
      </Fragment>
    );
  };
  useEffect(() => {
    setLeadId(match.params.id);
  }, []);
  useEffect(() => {
    if (getPocListing !== null && leadId)
      (async () => {
        setIsLoading(true);
        await getPocListing(leadId);
        setIsLoading(false);
      })();
  }, [getPocListing, leadId]);

  useEffect(() => {
    const tableData = [
      'id',
      'name',
      'designation',
      'contact_no',
      'email',
      'status',
    ];
    if (pocList && pocList.resultSets) {
      const data = pocList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Actions: {
              name: 'Edit Details',
              link: `${baseUrl}/edit-poc/${leadId}/${element.id}`,
              from: 'pocList',
            },
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(pocList.total / pocList.per_page));
    }
  }, [pocList]);

  const updateStatusPoc = async (val) => {
    let requestData = {};
    if (!val.check) {
      requestData = {
        poc_id: val.id,
        status: 2,
      };
    } else {
      requestData = {
        poc_id: val.id,
        status: 1,
      };
    }
    setReqData(requestData);
    await updatePocStatus(requestData).then(async (response) => {
      if (response) {
        await getPocListing(leadId);
      }
    });
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getPocListing(leadId, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.viewPOCs}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        onChange={(val) => {
          updateStatusPoc(val);
        }}
        pageCount={pageCount}
        srNo={pocList?.from}
        onPageChange={onPageChange}
      />
    </Layout>
  );
};

export default ViewPocs;
